export function jwtOptionsFactory() {
  return {
    tokenGetter: () => {
      return null;
    },
  };
}
